import { SpaceInfo } from '../state/SpaceInfo';
import { CallFavoritesReorderItem } from './AppActionTypes';
import { isActionFactory } from './isActionFactory';
import { ReorderItemAction } from './ReorderItem';

export interface CallReorderItemAction extends ReorderItemAction {}

export function callFavoritesReorder(fromIndex: number, indexToMoveAfter: number, spaceInfo: SpaceInfo): CallReorderItemAction {
  return {
    type: CallFavoritesReorderItem,
    spaceInfo,
    fromIndex,
    indexToMoveAfter: indexToMoveAfter,
  };
}

export const isCallReorderItemAction = isActionFactory<CallReorderItemAction>(CallFavoritesReorderItem);
